<template>
  <div class="returnPre" @click="goBack()"></div>
</template>

<script>
  export default {
    name: "returnPre",
    methods: {
      goBack() {
            // window.history.go(-1);
            window.location.href='http://m.itdks.com';
          }
        }
      }
    </script>

    <style scoped lang="less">
    .returnPre{
      width: 20vw;
      height: 8vw;
      background: url("../../assets/img/returnHome.png") no-repeat;
      background-size: 100% 100%;
      position: fixed;
      z-index: 20;
      left: 0;
      bottom: 20vw;
    }
  </style>



// WEBPACK FOOTER //
// src/components/Commons/returnPre.vue